import * as React from 'react';

import IconFileBase from './IconFileBase';
import { Icon } from '../iconTypes';

const IconFileDocument = (props: Icon) => (
    <IconFileBase {...props} baseClassName="icon-file-document">
        <path d="M25 27H7V5h13l5 5v17z" fill="#fff" />
        <path
            d="M20 4H7a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9.89zm5 23H7V5h13v4a1 1 0 0 0 1 1h4z"
            fill="#2a62b9"
        />
        <path d="M10 20h8v1h-8zm0-3h11v1H10zm0-3h11v1H10z" fill="#2a62b9" />
    </IconFileBase>
);

export default IconFileDocument;
